import {updateField} from 'vuex-map-fields';
import {UPDATE_TEMPLATE} from "./types";

export default {
    updateField,

    [UPDATE_TEMPLATE](state, payload) {
        state.templates = state.templates.map(template => {
            if (template.uuid === payload.uuid) {
                template = {...template, ...payload};
            }
            return template;
        })
    }
}